import React, { useState } from 'react';
import { CalendarPlus, Play, PartyPopper, Trash2 } from 'lucide-react';
import { LaborCreateCalendarModal } from './LaborCreateCalendarModal';
import { LaborGenerateDaysModal } from './LaborGenerateDaysModal';
import { LaborAddHolidayModal } from './LaborAddHolidayModal';
import { LaborDeleteHolidayModal } from './LaborDeleteHolidayModal';
import { LaborOverrideSetup } from './LaborOverrideSetup';

/**
 * Acciones de calendario de planta (vista Fábrica): dos modales independientes.
 * factoryId viene de resolveLaborFactoryId + FactoryContext (código del header → id numérico).
 */
export function LaborFactoryCalendarSetup({
  factoryId,
  factoryCode,
  year,
  calendarId = null,
  onAfterChange,
}) {
  const [createOpen, setCreateOpen] = useState(false);
  const [generateOpen, setGenerateOpen] = useState(false);
  const [addHolidayOpen, setAddHolidayOpen] = useState(false);
  const [deleteHolidayOpen, setDeleteHolidayOpen] = useState(false);
  const [lastMessage, setLastMessage] = useState(null);

  const handleSuccess = (message) => {
    setLastMessage({ type: 'success', text: message });
    onAfterChange?.();
  };

  return (
    <>
      <div className="mb-4 flex flex-wrap items-center gap-3 rounded-lg border border-gray-700 bg-gray-800/80 p-3">
        <span className="text-sm text-gray-400 mr-1">Calendario de planta:</span>
        <button
          type="button"
          onClick={() => setCreateOpen(true)}
          className="inline-flex items-center gap-2 px-3 py-2 rounded-lg bg-blue-600 hover:bg-blue-500 text-white text-sm font-medium"
        >
          <CalendarPlus className="w-4 h-4" />
          Crear calendario
        </button>
        <button
          type="button"
          onClick={() => setGenerateOpen(true)}
          className="inline-flex items-center gap-2 px-3 py-2 rounded-lg bg-emerald-600 hover:bg-emerald-500 text-white text-sm font-medium"
        >
          <Play className="w-4 h-4" />
          Generar días
        </button>
        <button
          type="button"
          onClick={() => setAddHolidayOpen(true)}
          className="inline-flex items-center gap-2 px-3 py-2 rounded-lg bg-violet-600 hover:bg-violet-500 text-white text-sm font-medium"
        >
          <PartyPopper className="w-4 h-4" />
          Añadir festivo
        </button>
        <button
          type="button"
          onClick={() => setDeleteHolidayOpen(true)}
          className="inline-flex items-center gap-2 px-3 py-2 rounded-lg bg-red-700 hover:bg-red-600 text-white text-sm font-medium"
        >
          <Trash2 className="w-4 h-4" />
          Quitar festivo
        </button>
        {lastMessage?.type === 'success' && (
          <span className="text-sm text-emerald-400">{lastMessage.text}</span>
        )}
      </div>

      <LaborOverrideSetup
        factoryId={factoryId}
        factoryCode={factoryCode}
        year={year}
        calendarId={calendarId}
        onAfterChange={onAfterChange}
      />

      <LaborCreateCalendarModal
        isOpen={createOpen}
        onClose={() => setCreateOpen(false)}
        factoryId={factoryId}
        factoryCode={factoryCode}
        year={year}
        onSuccess={(data) =>
          handleSuccess(
            data?.id
              ? `Calendario creado (ID ${data.id}). Usa «Generar días» para rellenar el año.`
              : 'Calendario creado.'
          )
        }
      />

      <LaborGenerateDaysModal
        isOpen={generateOpen}
        onClose={() => setGenerateOpen(false)}
        factoryId={factoryId}
        factoryCode={factoryCode}
        defaultYear={year}
        onSuccess={(data) =>
          handleSuccess(data?.message || `Días del año generados correctamente.`)
        }
      />

      <LaborAddHolidayModal
        isOpen={addHolidayOpen}
        onClose={() => setAddHolidayOpen(false)}
        factoryId={factoryId}
        factoryCode={factoryCode}
        defaultYear={year}
        onSuccess={(data) =>
          handleSuccess(
            data?.name
              ? `Festivo «${data.name}» registrado.`
              : 'Festivo registrado.'
          )
        }
      />

      <LaborDeleteHolidayModal
        isOpen={deleteHolidayOpen}
        onClose={() => setDeleteHolidayOpen(false)}
        factoryId={factoryId}
        factoryCode={factoryCode}
        defaultYear={year}
        onSuccess={() => handleSuccess('Festivo eliminado.')}
      />
    </>
  );
}
